import { render } from "./OtTable.vue?vue&type=template&id=deb2e9fa&scoped=true"
import script from "./OtTable.vue?vue&type=script&lang=js"
export * from "./OtTable.vue?vue&type=script&lang=js"

import "./OtTable.vue?vue&type=style&index=0&id=deb2e9fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deb2e9fa"]])

export default __exports__